import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39b1e267")

_pushScopeId("data-v-39b1e267")
const _hoisted_1 = { class: "FTLAdditionalFilters" }
const _hoisted_2 = { class: "FTLAdditionalFilters__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "header__title" }, "Фильтры", -1)
const _hoisted_4 = { class: "FTLAdditionalFilters__body" }
const _hoisted_5 = { class: "body__block body__calendar" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "body__title" }, "Выберите дату от или до", -1)
const _hoisted_7 = { class: "calendar" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "calendar__divider" }, null, -1)
const _hoisted_9 = { class: "body__block body__filters" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "body__title" }, "Выберите нужный фильтр", -1)
const _hoisted_11 = { class: "FTLAdditionalFilters__footer" }
const _hoisted_12 = { class: "footer__actions" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Сбросить ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_calendar = _resolveComponent("s-calendar")!
  const _component_selected_date_range = _resolveComponent("selected-date-range")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_icon_close, {
        class: "header__icon",
        onClick: _ctx.emitClose
      }, null, 8, ["onClick"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_s_calendar, {
            "with-range": "",
            range: _ctx.state.date_range,
            "onUpdate:range": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.date_range = $event)),
            "disable-less-date": false
          }, null, 8, ["range"]),
          (Boolean(_ctx.state.date_range.date_from))
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_8,
                (Boolean(_ctx.state.date_range.date_from))
                  ? (_openBlock(), _createBlock(_component_selected_date_range, {
                      key: 0,
                      range: _ctx.state.date_range
                    }, null, 8, ["range"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_multiselect, {
          modelValue: _ctx.state.sender_city,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.sender_city = $event)),
          options: _ctx.filtersCitiesState.data,
          loading: _ctx.filtersCitiesState.state.is_loading,
          object: true,
          label: "name",
          trackBy: "name",
          placeholder: "Город отправителя",
          searchable: "",
          noResultsText: "Ничего не найдено",
          noOptionsText: "Список пуст"
        }, null, 8, ["modelValue", "options", "loading"])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_s_button, {
          class: "green outline",
          onClick: _ctx.resetFiltersHandler
        }, {
          default: _withId(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_s_button, {
          class: "green",
          onClick: _ctx.applyFilters
        }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
})